import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './page.component.html',
  styles: [
  ]
})
export class PageComponent {


}
